export const satelliteCheck = {
  path: '/api/v1/satellite',
  method: 'GET',
};

export function searchSatelliteReceivers(search, contentType) {
  return {
    accept: contentType,
    path: `satellite/receivers${search}`,
  };
}
